module.exports = __webpack_public_path__ + "img/as-seen-on.png";